import React from "react";
import Slider from "react-slick";

import ava01 from "../../../assets/images/03650000-6bec-ac1f-0fad-08dac1891ec5.webp";
import ava02 from "../../../assets/images/01330000-6bec-ac1f-6098-08db2a9ed11c.webp";
import ava03 from "../../../assets/images/01330000-6bec-ac1f-d1d2-08db28725502.webp";

import "../../../styles/slider.css";

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 3000,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <Slider {...settings}>
      <div>
        
        <div className=" slider__content d-flex align-items-center gap-3 ">
          <img src={ava01} alt="avatar"  className=" rounded" />
          
        </div>
      </div>
      <div>
      
        <div className="slider__content d-flex align-items-center gap-3 ">
          <img src={ava02} alt="avatar" className=" rounded" />
          
        </div>
      </div>
      <div>
      
        <div className="slider__content d-flex align-items-center gap-3 ">
          <img src={ava03} alt="avatar" className=" rounded" />
          
        </div>
      </div>
    </Slider>
  );
};

export default TestimonialSlider;
